export default __webpack_public_path__ + "static/media/retiro_seclantas5.79d0d379.jpg";